import React from "react";
import { useTranslation } from "react-i18next";
import { FLAG_COMPONENTS } from "../../common/flags/FlagIcons";
import { LANGUAGES } from "../constants";
import styles from "../OnboardingWizard.module.scss";

interface Props {
  value: string;
  onChange: (code: string) => void;
}

const LanguageStep: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.stepContent}>
      <h2 className={styles.stepTitle}>{t("onboarding.languageTitle")}</h2>
      <p className={styles.stepSubtitle}>{t("onboarding.languageSubtitle")}</p>

      <div className={styles.grid2x2}>
        {LANGUAGES.map((lang) => {
          const FlagIcon = FLAG_COMPONENTS[lang.code];
          const selected = value === lang.code;
          return (
            <button
              key={lang.code}
              type="button"
              className={`${styles.card} ${selected ? styles.cardSelected : ""}`}
              onClick={() => onChange(lang.code)}
            >
              {FlagIcon && <FlagIcon size={32} />}
              <span className={styles.cardLabel}>{lang.nameKey}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageStep;
